import * as React from 'react'

const Unauthorized = () => {
	const path = window.location.pathname
	const frompath = sessionStorage.getItem('fromPath')
	return (
		<div className="unauth-page">
			<h2 data-testid="unauth-header">Unauthorized</h2>
			<br />
			<p>You do not have access to the requested page.</p>
			<div>
				{path != '/unauth' ?
					<button className="go-back"
						onClick={() => window.history.length > 0 ?
							frompath ? window.location.href = frompath:	window.history.back()
							: window.location.href = '/'}
					>Go Back</button> :
					<button className="go-back"
						onClick={() => { window.location.href = '/front' }}
					>Login</button>}
			</div>
		</div>
	)
}

export default Unauthorized
